import { api, baseUrl } from "../api";
export const cardApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCard: build.query({
            query: (args) => ({
                url: `program-service/api/v1/widget/user/card`,
                headers: {
                    "X-Loyalty-Language": (args.locale).split('-')[0],
                    "Authorization": `Bearer ${args.jwt}`
                },
                credentials: "include"
            }),
            forceRefetch: () => true
        }),
        getGoogleWalletUrl: build.query({
            query: (args) => ({
                url: `wallet-service/api/v1/wallet/google`,
                headers: {
                    "X-Loyalty-Language": (args.locale).split('-')[0],
                    "Authorization": `Bearer ${args.jwt}`
                },
                forceRefetch: () => true
            })
        }),
        getAppleWalletUrl: build.query({
            query: (args) => ({
                url: `auth-manager/api/v1/short-lived-token`,
                method: 'POST',
                headers: {
                    'X-Loyalty-Language': (args.locale).split('-')[0],
                    'Authorization': `Bearer ${args.jwt}`,
                },
                forceRefetch: () => true
            }),
            transformResponse: async (response, meta, arg) => {
                return `${baseUrl}wallet-service/api/v1/wallet/apple?Authorization=${arg.jwt}`;
            },
        })
    })
});
//# sourceMappingURL=card.api.js.map